
(async function () {
  const organizations = {
    "/pages/kctc-virtual-food-drive": {
      name: "KCTC Virtual Food Drive",
      code: "KCTC001",
      subdomain: "kctc.shreddingfundraising.com"
    },

    "/pages/harding-university-pi-theta-phi-virtual-food-drive": {
      name: "Harding University - Pi Theta Phi Virtual Food Drive",
      code: "HARDING001",
      subdomain: "harding.shreddingfundraising.com"
    },

    "/pages/tcu-sigma-lambda-alpha": {
      name: "TCU - Sigma Lambda Alpha",
      code: "TCU001",
      subdomain: "tcu.shreddingfundraising.com"
    },

    "/pages/university-of-delaware-food-drive": {
      name: "University of Delaware Food Drive",
      code: "UDEL001",
      subdomain: "udel.shreddingfundraising.com"
    },

    "/pages/northwestern-university-food-drive": {
      name: "Northwestern University Food Drive",
      code: "NU001",
      subdomain: "nu.shreddingfundraising.com"
    }
  };

  const hostname = window.location.hostname;
  const path = window.location.pathname.replace(/\/$/, "");

  // Identify the organization by subdomain first.
  let organization = Object.values(organizations).find(
    (org) => org.subdomain === hostname
  );

  // Fall back to the landing page URL.
  if (!organization) {
    organization = organizations[path];
  }

  if (!organization) return;

  const root = window.Shopify?.routes?.root || "/";

  try {
    const response = await fetch(root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        attributes: {
          "Donation Organization": organization.name,
          "Organization Code": organization.code,
          "Source Subdomain": organization.subdomain
        }
      })
    });

    if (!response.ok) {
      throw new Error("Unable to update cart");
    }

    console.log(
      "Donation organization assigned:",
      organization.code
    );
  } catch (error) {
    console.error("Donation tracking error:", error);
  }
})();
